import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, ControlContainer } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

import { MultiSelectionOptions, MultiSelectionOption } from 'commons-lib';

import { SnackbarService } from '../../../snackbar/service/snackbar.service';
import { CheckTaskStatusService } from 'src/app/core/services/check-task-status-service/check-task-status-service';
import { EditFacModalService } from '../../service/edit-fac-modal.service';
import { FullFacModel } from '../../../../../core/models/edit-fac-modal.model';
import { EnvironmentService } from 'src/app/core/enviroment/environment.service';

@Component({
  selector: 'app-edit-modal-search-profile',
  templateUrl: './edit-modal-search-profile.component.html',
  styleUrls: ['./edit-modal-search-profile.component.scss']
})
export class EditModalSearchProfileComponent implements OnInit {

  @Input() show = false;
  @Input() facItem: FullFacModel;
  @Input() searchProfileEditObj = {
    id: null,
    idx: 0
  };
  @Output() closeModal = new EventEmitter<boolean>();

  public moresSearchProfile: FormGroup;
  public dropdownsState = {
    business_type: false,
    property_type: false,
    state: false,
    city: false,
    neighborhood_or_value_zone: false
  };
  public loader = false;
  public showError = {
    cash: false,
    area: false
  };
  public invalid = true;

  public roomQnt = new MultiSelectionOptions([
    new MultiSelectionOption('1', JSON.stringify({operation: 'EQL', value: 1})),
    new MultiSelectionOption('2', JSON.stringify({operation: 'EQL', value: 2})),
    new MultiSelectionOption('3', JSON.stringify({operation: 'EQL', value: 3})),
    new MultiSelectionOption('4+', JSON.stringify({operation: 'GTE', value: 4}))
  ]);

  public suitesQnt = new MultiSelectionOptions([
    new MultiSelectionOption('1', JSON.stringify({operation: 'EQL', value: 1})),
    new MultiSelectionOption('2', JSON.stringify({operation: 'EQL', value: 2})),
    new MultiSelectionOption('3', JSON.stringify({operation: 'EQL', value: 3})),
    new MultiSelectionOption('4+', JSON.stringify({operation: 'GTE', value: 4}))
  ]);

  public parkingQnt = new MultiSelectionOptions([
    new MultiSelectionOption('1', JSON.stringify({operation: 'EQL', value: 1})),
    new MultiSelectionOption('2', JSON.stringify({operation: 'EQL', value: 2})),
    new MultiSelectionOption('3', JSON.stringify({operation: 'EQL', value: 3})),
    new MultiSelectionOption('4+', JSON.stringify({operation: 'GTE', value: 4}))
  ]);

  public listState: any[] = [];
  public listCity: any [] = [];
  public listNeighborhoods: any [] = [];
  public listProductType: any [] = [];

  public listLocation = [
    {
      name: 'Locação'
    },
    {
      name: 'Venda'
  }];

  constructor(
    private controlContainer: ControlContainer,
    private snackbarService: SnackbarService,
    private checkStatusService: CheckTaskStatusService,
    private editFacService: EditFacModalService,
    private translate: TranslateService,
    private environmentService: EnvironmentService
  ) { }

  ngOnInit() {
    this.moresSearchProfile = this.controlContainer.control as FormGroup;
    this.selectToggles();
    this.validateForm(this.moresSearchProfile.getRawValue());
    this.moresSearchProfile.valueChanges.subscribe(result => this.validateForm(result));
    this.editFacService.getProductTypes().subscribe((x: any) => this.listProductType = x.types);
    this.editFacService.getStates('brasil').subscribe((x: any) => {
      this.listState = x;
      if (this.moresSearchProfile.get('state').value) {
        this.getListCity(this.getItem(this.moresSearchProfile.get('state'), this.listState)[0]?.id);
      }
    });
  }

  public getItem(formControl, list: any[]): any[] {
    let data = [];
    if (formControl.value) {
      data = list.filter(x => x.name === formControl.value);
    }
    return data;
  }

  public clearText(): void {
    this.moresSearchProfile.get('city').setValue(null);
    this.moresSearchProfile.get('neighborhood_or_value_zone').setValue(null);
    this.listCity = [];
    this.listNeighborhoods = [];
  }

  public getListCity(data: string) {
    if (data) {
      this.editFacService.getLocations(data).subscribe((x: any) => {
        this.listCity = x;
        if (this.moresSearchProfile.get('city').value) {
          this.getNeighborhoods(this.getItem(this.moresSearchProfile.get('city'), this.listCity)[0]?.id);
        }
      });
    }
  }

  public getNeighborhoods(data: string) {
    if (data) {
      this.editFacService.getNeighborhoods(data).subscribe((x: any) => this.listNeighborhoods = x);
    }
  }

  public clearSearchProduct(field: string): void {
    this.moresSearchProfile.get(field).setValue(null);
    this.listNeighborhoods = [];
  }

  public clearProperty() {
    this.moresSearchProfile.get('property_type').patchValue(null);
  }

  public clearCityAndNeighborhoods() {
    this.listCity = [];
    this.listNeighborhoods = [];
    this.moresSearchProfile.get('state').patchValue(null);
    this.moresSearchProfile.get('city').patchValue(null);
    this.moresSearchProfile.get('neighborhood_or_value_zone').patchValue(null);
  }

  public getProductTypes() {
    this.editFacService.getProductTypes().subscribe((x: any) => this.listProductType = x.types);
  }

  validateForm(result) {
    function validateInputRange(minField, maxField) {
      if (parseFloat(minField) > parseFloat(maxField)) {
        return true;
      }
      return false;
    }

    if (validateInputRange(result.min_cash_value, result.max_cash_value)) {
      this.showError.cash = true;
      return;
    } else {
      this.showError.cash = false;
    }

    if (validateInputRange(result.min_area_value, result.max_area_value)) {
      this.showError.area = true;
      return;
    } else {
      this.showError.area = false;
    }

    for (const key in result) { // Check if has some value
      if (
        result[key] !== null &&
        result[key] !== ''
        ) {
        this.invalid = false;
        return;
      }
    }

    this.invalid = true;
  }

  clickMultiToggle(multi: MultiSelectionOption[], formKey: string) {
    this.moresSearchProfile.get(formKey).patchValue(multi.map(item => {
      return JSON.parse(item.getValue());
    }));

    if (this.moresSearchProfile.get(formKey).value.length === 0) {
      this.moresSearchProfile.get(formKey).patchValue(null);
    }
  }

  selectToggles() {
    const loopCheck = (formName: string, toggle: MultiSelectionOptions) => {
      if (!this.moresSearchProfile.get(formName).value) {
        return;
      }
      this.moresSearchProfile.get(formName).value.forEach(element => {
        for (const iterator of toggle.items) {
          const currentValue = JSON.parse(iterator.getValue()).value;
          if (currentValue === element.value) {
            iterator.toggle();
            continue;
          }
        }
      });
    };

    loopCheck('bedrooms', this.roomQnt);
    loopCheck('suites', this.suitesQnt);
    loopCheck('garage_spaces', this.parkingQnt);
  }

  updateDropdownValue(field: string, value: any, dropdown: string) {
    if (field === 'city') {
      this.listNeighborhoods = [];
      this.moresSearchProfile.get('neighborhood_or_value_zone').setValue(null);
    }
    this.moresSearchProfile.get(field).patchValue(value);
    this.moresSearchProfile.markAsDirty();
    this.dropdownsState[dropdown] = false;
  }

  saveModal() {
    if (this.invalid || this.showError.cash || this.showError.area) {
      return;
    }
    this.loader = true;
    if (this.searchProfileEditObj.id) {
     this.editSearch();
    } else {
     this.createSearch();
    }
  }


  editSearch() {
    this.editFacService.patchFacSearchProfile(
      this.facItem.id,
      this.searchProfileEditObj.id,
      this.moresSearchProfile.getRawValue()
    ).subscribe(resp => {
      this.checkStatusService.checkTaskStatus2(resp.taskId, this.environmentService.getEnvVar('api_facs')).subscribe(msg => {
        if (msg.status && msg.status.name === 'Successful') {
          const newSeachProfile = this.moresSearchProfile.getRawValue();
          newSeachProfile.id = this.searchProfileEditObj.id;
          this.facItem.search_profiles[this.searchProfileEditObj.idx] = newSeachProfile;
          this.snackbarService.show('O perfil de busca foi alterado', 'success');
          this.loader = false;
          this.closeModal.emit();
        }
        if (msg.status && msg.status.name === 'Failure') { this.errorCreateSearch(msg); }
        this.loader = false;
      }, err => this.errorCreateSearch(err));
    }, err => {
      this.errorCreateSearch(err);
      this.loader = false;
    });
  }

  createSearch() {
    this.editFacService.postFacSearchProfile(this.facItem.id, this.moresSearchProfile.getRawValue()).subscribe(resp => {
      this.checkStatusService.checkTaskStatus2(resp.taskId, this.environmentService.getEnvVar('api_facs')).subscribe(msg => {
        if (msg.status && msg.status.name === 'Successful') {
          const newSeachProfile = this.moresSearchProfile.getRawValue();
          newSeachProfile.id = msg.task_id;
          this.facItem.search_profiles.push(newSeachProfile);
          this.snackbarService.show('O perfil de busca foi adicionado', 'success');
          this.closeModal.emit();
        }
        if (msg.status && msg.status.name === 'Failure') { this.errorCreateSearch(msg); }
        this.loader = false;
      }, err => this.errorCreateSearch(err));
    }, err => {
      this.errorCreateSearch(err);
      this.loader = false;
    });
  }

  errorCreateSearch(err): void {
    if (err.messages) {
      this.snackbarService.show(err.messages[0].message, 'error', 10);
    } else {
      this.snackbarService.show('Não foi possível realizar esta ação, tente novamente mais tarde', 'error', 10);
    }
    this.loader = false;
    this.closeModal.emit();
  }

  public removeCaracter(event) {
    event.target.value = event.target.value.replace(/[^0-9\.]+/g, '');
  }

  public typeList = (data: string): string => {
    if (data === 'neighborhood') {
      return 'Bairro';
    } else {
      return 'Zona de Valor';
    }
  }

  public closed() {
    this.closeModal.emit(true);
  }

}
